import palette from 'theming/palette';
import typography from 'theming/typography';

export default {
	styleOverrides: {
		root: { ...typography.h2, color: palette.mainTextColor }
	}
};
